import type { ChangelogEntry } from "../types";

/** VIB-3050 PR 1: «Ikke relevant» heter «Avvist», og tastene følger rekkefølgen fra arket. */
export const LEADS_AVVIST_2026_11: ChangelogEntry = {
  id: "2026-11-03-leads-avvist",
  date: "2026-11-03",
  title: "Leads: «Avvist» og nye taster på leadkortet",
  summary:
    "«Ikke relevant» heter nå «Avvist», og tastene er byttet om så de vanligste utfallene ligger først. Velger du årsaken «Annet», må du skrive hva de sa.",
  sections: [
    {
      heading: "Leads",
      items: [
        {
          title: "Nye taster",
          kind: "forbedret",
          body: "1 Ikke svar, 2 Ring tilbake senere, 3 Sendt e-post, 4 Avtalt møte, 5 Avvist og 6 Feil nummer. Knappene på leadkortet står i samme rekkefølge.",
        },
        {
          title: "«Avvist» i stedet for «Ikke relevant»",
          kind: "forbedret",
          body: "Utfallet heter «Avvist» på leadkortet, i historikken og i Leadlister. Årsakene og datoen for ny vurdering er de samme som før.",
        },
        {
          title: "«Annet» krever en forklaring",
          kind: "forbedret",
          body: "Velger du årsaken «Annet», kan du ikke lagre før du har skrevet hva de sa, så avvisningen kan vurderes senere.",
        },
      ],
    },
  ],
};
